import CopiedIcon from '@/assets/copied-icon.svg?url';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useStyles from './CopyComponent.styles';

const CopiedText = () => {
  const classes = useStyles({});

  return (
    <Box className={classes.copiedContainer}>
      <Box
        component="img"
        alt="Copied Icon"
        src={CopiedIcon}
        className={classes.copiedIcon}
      />

      <Typography className={classes.copiedText}>Copied</Typography>
    </Box>
  );
};

export default CopiedText;
